export default __webpack_public_path__ + "static/media/user-profile.90632b67.svg";